var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnarchiveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.3.709h7.6c.7 0 1.3.263 1.8.73l2 2.003c.5.467.7 1.101.7 1.761v9.617c0 1.375-1.1 2.49-2.5 2.49H3.3c-1.4 0-2.5-1.115-2.5-2.49V5.203c0-.66.3-1.294.8-1.761l2-2.003C4 .972 4.7.709 5.3.709Zm8.2 1.903 1.4 1.417H3.3l1.4-1.417c.2-.155.4-.243.6-.243h7.6c.3 0 .5.088.6.243ZM2.5 6.9v7.92c0 .458.4.83.8.83h11.6c.5 0 .9-.372.9-.83V6.9l-1.6 2.232c-.3.443-.8.708-1.3.708H5.4c-.5 0-1-.265-1.3-.708L2.5 6.9Zm12.1-1.211H3.7L5.4 8.18h7.5l1.7-2.491Z",
  fill: "currentColor"
})));
export default SvgUnarchiveIcon;